import { execAdmin } from '../utils';

interface ScheduleCatalogUploadVariables {
  partnerCode: string;
  source?: string;
  sourcePartnerCode?: string;
  useExistingUpload?: boolean;
  scheduledAt?: string;
  timezone?: string;
  totalRowCount?: number;
  awsKey?: string;
  filename?: string;
}

interface ScheduleCatalogUploadResponse {
  scheduleCatalogUpload: {
    id: number;
    location: string;
    partnerCode: string;
  };
}

const SCHEDULE_CATALOG_UPLOAD_MUTATION = `
  mutation scheduleCatalogUpload(
    $partnerCode: String
    $source: String
    $sourcePartnerCode: String
    $useExistingUpload: Boolean
    $scheduledAt: String
    $timezone: String
    $totalRowCount: Int
    $awsKey: String
    $filename: String
  ) {
    scheduleCatalogUpload(
      partnerCode: $partnerCode
      source: $source
      sourcePartnerCode: $sourcePartnerCode
      useExistingUpload: $useExistingUpload
      scheduledAt: $scheduledAt
      timezone: $timezone
      totalRowCount: $totalRowCount
      awsKey: $awsKey
      filename: $filename
    ) {
      id
      location
      partnerCode
    }
  }
`;

export const scheduleCatalogUpload = async (
  variables: ScheduleCatalogUploadVariables,
): Promise<ScheduleCatalogUploadResponse> => {
  return execAdmin<ScheduleCatalogUploadVariables, ScheduleCatalogUploadResponse>(
    SCHEDULE_CATALOG_UPLOAD_MUTATION,
    { variables },
  );
};
